
















import { Component, Vue, Watch } from 'vue-property-decorator';
import { DxTabs } from 'devextreme-vue';

@Component({
  components: {
    DxTabs,
  },
})
export default class SalesNavigation extends Vue {
    private navIndex: number = 0;
    private initialised: boolean = false;

    private mounted() {
        switch (this.$route.name) {
            case 'quotationsOverview':
                this.navIndex = 0;
                break;
            case 'invoicesOverview':
                this.navIndex = 1;
                break;
            case 'creditnotesOverview':
                this.navIndex = 2;
                break;
        }

        setTimeout(() => {
            this.initialised = true;
        }, 150);
    }

    get navbarItems() {
        const self = this;
        return [
            { icon: 'fas fa-file', text: 'Offertes'},
            { icon: 'fas fa-file-invoice', text: 'Facturen'},
            { icon: 'fas fa-file-excel', text: 'Creditnota\'s'},
        ];
    }

    @Watch('navIndex')
    private onNavIndexChanged(value: number, oldValue: number) {
        if (value === -1) {
            setTimeout(() => {
                this.navIndex = 0;
            }, 150);
        } else {
            if (this.initialised) {
                switch (value) {
                    case 0:
                        this.$router.push({ path: `/quotations` });
                        break;
                    case 1:
                        this.$router.push({ path: `/invoices` });
                        break;
                    case 2:
                        this.$router.push({ path: `/creditnotes` });
                        break;
                }
            }
        }
    }
}
